import { localizeCurrencyValue } from '@mews-commander/utils';

export const getNonZeroCurrencyValue = (amount: $TSFixMe, currencyCode: $TSFixMe) => {
    if (amount === 0) {
        return '';
    }

    return localizeCurrencyValue({ value: amount, currency: currencyCode }, { showSymbol: false });
};
